import { PencilOff } from "lucide-react"
import { Trash2 } from "lucide-react"
import { Pencil } from "lucide-react"
import { Minus } from "lucide-react"
import { Plus } from "lucide-react"

const ActionToolbar = ({ onCreate, isFormOpen, onUpdate, hasChanged, onDelete }) => {
  return (
    <div className="flex justify-end gap-1.5 py-2">
      <button
        onClick={onCreate}
        className="rounded-sm border border-gray-500 text-gray-500 px-2 py-1.5 hover:bg-gray-100 cursor-pointer"
      >
        {isFormOpen ? (
          <p className="flex gap-2 items-center px-1">
            <Minus size={16} /> 닫기
          </p>
        ) : (
          <p className="flex gap-2 items-center px-1">
            <Plus size={16} /> 추가
          </p>
        )}
      </button>

      <button
        disabled={!hasChanged}
        onClick={onUpdate}
        className="rounded-sm border
          border-blue-500 text-blue-500
          px-2 py-1.5
          cursor-pointer disabled:cursor-not-allowed
          disabled:border-gray-300 disabled:text-gray-300
          hover:disabled:bg-gray-100 hover:bg-blue-100
        "
      >
        <p className="flex gap-2 items-center px-1">
          {hasChanged ? <Pencil size={16} /> : <PencilOff size={16} />} 편집
        </p>
      </button>

      <button
        onClick={onDelete}
        className="rounded-sm border 
          border-red-500 text-red-500
          px-2 py-1.5 
          hover:bg-red-100 cursor-pointer
        "
      >
        <p className="flex gap-2 items-center px-1">
          <Trash2 size={16} />
          삭제
        </p>
      </button>
    </div>
  )
}

export default ActionToolbar
